var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInvoiceIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 26,
    viewBox: "0 0 27 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.0002 16.2502V19.5002H7.00016V16.2502H4.8335V19.5002C4.8335 20.6918 5.8085 21.6668 7.00016 21.6668H20.0002C21.1918 21.6668 22.1668 20.6918 22.1668 19.5002V16.2502H20.0002ZM18.9168 11.9168L17.3893 10.3893L14.5835 13.1843V4.3335H12.4168V13.1843L9.611 10.3893L8.0835 11.9168L13.5002 17.3335L18.9168 11.9168Z",
    fill: "#1D5E6D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInvoiceIcon);
export default __webpack_public_path__ + "static/media/invoiceIcon.fda9598632ffbd8a77e361fc540d68f8.svg";
export { ForwardRef as ReactComponent };